(function () {
  var locations = [
    {
      value: 'beyond-the-beach-ocean',
      label: 'Beyond The Beach Ocean',
      match: /beyond the beach ocean/i
    },
    {
      value: 'beyond-the-beach',
      label: 'Beyond The Beach',
      match: /beyond the beach/i
    },
    {
      value: 'beyond-the-street',
      label: 'Beyond The Street',
      match: /beyond the street/i
    },
    {
      value: 'beyond-the-bike-giant',
      label: 'Beyond The Bike & Giant',
      match: /beyond the bike\s*&\s*giant/i
    },
    {
      value: 'seafolly',
      label: 'Seafolly',
      match: /\bseafolly\b/i
    },
    {
      value: 'tommy-bahama',
      label: 'Tommy Bahama',
      match: /\btommy bahama\b/i
    },
    {
      value: 'rip-curl',
      label: 'Rip Curl',
      match: /\brip curl\b/i
    },
    {
      value: 'oakley',
      label: 'Oakley',
      match: /\boakley\b/i
    }
  ];

  var filterId = 'custom-store-location-filter';
  var selectId = 'custom-store-location-select';

  function getCards() {
    return Array.prototype.slice.call(
      document.querySelectorAll('#storeify_location .item.thumbnail')
    );
  }

  function getMarkers() {
    return Array.prototype.slice.call(
      document.querySelectorAll('#map .storeify-advanced-marker')
    );
  }

  function getLocationFromText(text) {
    text = (text || '').replace(/\s+/g, ' ');

    for (var i = 0; i < locations.length; i++) {
      if (locations[i].match.test(text)) {
        return locations[i].value;
      }
    }

    return '';
  }

  function getCardLocation(card) {
    return getLocationFromText(card.textContent);
  }

  function getMarkerLocation(marker) {
    return getLocationFromText(marker.getAttribute('aria-label'));
  }

  function getUrlLocation() {
    var params = new URLSearchParams(window.location.search);
    var location = params.get('location');

    if (location) {
      return location.toLowerCase();
    }

    for (var i = 0; i < locations.length; i++) {
      if (params.has(locations[i].value)) {
        return locations[i].value;
      }
    }

    return '';
  }

  function updateUrl(location) {
    var url = new URL(window.location.href);

    if (location) {
      url.searchParams.set('location', location);
    } else {
      url.searchParams.delete('location');
    }

    window.history.replaceState({}, '', url);
  }

  function filterStores(location) {
    var cards = getCards();
    var visibleCount = 0;

    cards.forEach(function (card) {
      var cardLocation = getCardLocation(card);
      var shouldShow = !location || cardLocation === location;

      card.hidden = !shouldShow;

      if (shouldShow) {
        visibleCount++;
      }
    });

    var countElement = document.getElementById('num-rs');

    if (countElement) {
      countElement.textContent = visibleCount;
    }

    getMarkers().forEach(function (marker) {
      var markerLocation = getMarkerLocation(marker);
      var shouldShow = !location || markerLocation === location;

      marker.style.display = shouldShow ? '' : 'none';
    });
  }

  function createFilter() {
    var existing = document.getElementById(filterId);

    if (existing) {
      return existing.querySelector('select');
    }

    var results = document.getElementById('results-slt');

    if (!results) {
      return null;
    }

    var wrapper = document.createElement('div');
    wrapper.id = filterId;

    var label = document.createElement('label');
    label.htmlFor = selectId;
    label.textContent = 'Filter by brand';

    var select = document.createElement('select');
    select.id = selectId;

    var allOption = document.createElement('option');
    allOption.value = '';
    allOption.textContent = 'All Brands';
    select.appendChild(allOption);

    locations.forEach(function (location) {
      var option = document.createElement('option');
      option.value = location.value;
      option.textContent = location.label;
      select.appendChild(option);
    });

    select.addEventListener('change', function () {
      filterStores(select.value);
      updateUrl(select.value);
    });

    wrapper.appendChild(label);
    wrapper.appendChild(select);

    results.parentNode.insertBefore(wrapper, results);

    return select;
  }

  function initialise() {
    var select = createFilter();

    if (!select) {
      return;
    }

    var urlLocation = getUrlLocation();
    var validLocation = locations.some(function (location) {
      return location.value === urlLocation;
    });

    select.value = validLocation ? urlLocation : '';
    filterStores(select.value);

    if (validLocation && urlLocation) {
      updateUrl(urlLocation);
    }
  }

  function reapplyFilter() {
    var select = document.getElementById(selectId);

    if (select) {
      filterStores(select.value);
    }
  }

  var observedContainerIds = {};

  function observeContainer(id) {
    if (observedContainerIds[id]) {
      return true;
    }

    var container = document.getElementById(id);

    if (!container) {
      return false;
    }

    var containerObserver = new MutationObserver(reapplyFilter);

    containerObserver.observe(container, {
      childList: true,
      subtree: true
    });

    observedContainerIds[id] = true;

    return true;
  }

  function observeStoreList() {
    var storeListObserved = observeContainer('storeify_location');
    var mapObserved = observeContainer('map');

    return storeListObserved && mapObserved;
  }

  initialise();

  if (!observeStoreList()) {
    var bootstrapObserver = new MutationObserver(function () {
      if (observeStoreList()) {
        bootstrapObserver.disconnect();
        initialise();
      }
    });

    bootstrapObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
